import { SET_ACCESS_CODE, SET_ACCESS_CODES_LIST } from "./types";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getAccessCode = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/access-codes`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ACCESS_CODE, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const getGuestAccessCodes = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/access-codes/guest`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ACCESS_CODES_LIST, payload: response.data.accessCodes });
    }
    catch (error) { errorHandler(error, null); }
};

export const newAccessCode = (guest = false, formValues = {}, onFieldError = null) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/access-codes${guest ? "/guest" : ""}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            if (guest) history.go(0);
            else dispatch({ type: SET_ACCESS_CODE, payload: response.data });
        }
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const invalidateAccessCode = (subID = null) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/access-codes${subID ? `/guest/${subID}` : ""}`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            if (!subID) dispatch({ type: SET_ACCESS_CODE, payload: response.data });
            history.go(0);
        }
    }
    catch (error) { errorHandler(error, null); }
};
